import { useContext } from "react";
import "./App.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import DashboardLayout from "pages/dashboard/layout";
import Modal from "react-modal";
import { Toaster } from "react-hot-toast";
import { linkRoleAccess } from "ui/dashboard/link-role-access";
import Ward from "route-ward";
import { ErrorBoundary } from "react-error-boundary";
import { fallbackRender } from "pages/fallbackPage";
import { Suspense } from "react";
import SideNav from "ui/dashboard/sidenav";
Modal.setAppElement("#root");

function GlobalDefs() {
  return (
    <svg
      width={0}
      height={0}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter
          id="filter0_b_21369_130105"
          x="-10.6527"
          y="-10.6191"
          width="43.2861"
          height="43.2617"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_21369_130105"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_21369_130105"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_21369_130105"
          x1="10.9905"
          y1="-0.015625"
          x2="10.9905"
          y2="22.0414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F79B1C" />
          <stop offset="1" stopColor="#DB7FFB" />
        </linearGradient>
      </defs>
      <defs>
        <filter
          id="filter0_b_21369_130118"
          x="-10.6527"
          y="-10.6191"
          width="43.2861"
          height="43.2617"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="3" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_21369_130118"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_21369_130118"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_21369_130118"
          x1="10.9905"
          y1="-0.015625"
          x2="10.9905"
          y2="22.0414"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F79B1C" />
          <stop offset="1" stopColor="#DB7FFB" />
        </linearGradient>
      </defs>
      <mask
        id="mask0_21369_130105"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="20"
        height="20"
      >
        <path
          d="M2.64004 7.22398L4.05171 8.63565C3.80421 9.37815 3.66671 10.1757 3.66671 11.0007C3.66671 15.0431 6.95754 18.334 11 18.334C15.0425 18.334 18.3334 15.0431 18.3334 11.0007C18.3334 6.95815 15.0425 3.66732 11 3.66732C10.175 3.66732 9.37754 3.80482 8.63504 4.05232L7.23254 2.64982C8.38754 2.12732 9.66171 1.83398 11 1.83398C16.06 1.83398 20.1667 5.94065 20.1667 11.0007C20.1667 16.0607 16.06 20.1673 11 20.1673C5.94004 20.1673 1.83337 16.0607 1.83337 11.0007C1.83337 9.65315 2.12671 8.37898 2.64004 7.22398ZM6.41671 5.04232C6.41671 5.80315 5.80254 6.41732 5.04171 6.41732C4.28087 6.41732 3.66671 5.80315 3.66671 5.04232C3.66671 4.28148 4.28087 3.66732 5.04171 3.66732C5.80254 3.66732 6.41671 4.28148 6.41671 5.04232ZM11.0275 8.24148H10.9634L9.90004 11.2757H12.0909L11.0275 8.24148ZM10.3492 6.87565H11.66L14.4192 14.209H13.145L12.485 12.339H9.52421L8.85504 14.209H7.59004L10.3492 6.87565Z"
          fill="#222222"
        />
      </mask>
      <mask
        id="mask0_21369_130118"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="3"
        y="1"
        width="16"
        height="20"
      >
        <path
          d="M11 1.83398L3.66663 4.58398V10.1665C3.66663 14.7957 6.79246 19.1131 11 20.1673C15.2075 19.1131 18.3333 14.7957 18.3333 10.1665V4.58398L11 1.83398ZM16.5 10.1665C16.5 13.8332 14.1625 17.2248 11 18.2607C7.83746 17.2248 5.49996 13.8423 5.49996 10.1665V5.85815L11 3.79565L16.5 5.85815V10.1665Z"
          fill="#222222"
        />
      </mask>
    </svg>
  );
}

export default function App() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const logError = (error: Error, info: { componentStack: string }) => {
    // Do something with the error, e.g. log to an external API
  };
  return (
    <>
      <ErrorBoundary
        fallbackRender={fallbackRender}
        onReset={() => navigate("/login")}
        onError={logError}
      >
        <GlobalDefs />
        <Suspense
          fallback={
            <div className="w-screen h-screen flex bg-[#F6F8FA] flex-col md:flex-row md:overflow-hidden relative">
              <div className="w-full flex-none md:w-24">
                <SideNav fromFallback={true} />
              </div>
              <div className="flex-grow overflow-y-auto flex justify-center items-center bg-slate-50 ">
                <div
                  className="ml-1 text-neutral-400  inline-block h-6 w-6 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                  role="status"
                ></div>
              </div>
            </div>
          }
        >
          <Routes>
            {linkRoleAccess.map((link) => {
              if (
                !link.public &&
                //@ts-ignore
                !link.role?.includes(user.role) &&
                //@ts-ignore
                !link.role?.includes("*")
              ) {
                return null;
              }
              let routeResult;
              if (link.LayoutElement) {
                routeResult = (
                  <Route key={link.path} element={link.LayoutElement}>
                    <Route path={link.path} element={<Ward route={link} />} />
                  </Route>
                );
              } else {
                routeResult = (
                  <Route
                    key={link.path}
                    path={link.path}
                    element={<Ward route={link} />}
                  />
                );
              }
              if (link.path.startsWith("/dashboard")) {
                routeResult = (
                  <Route key={link.path} element={<DashboardLayout />}>
                    {routeResult}
                  </Route>
                );
              }
              return routeResult;
            })}
          </Routes>
        </Suspense>
      </ErrorBoundary>
      <Toaster
        containerStyle={{
          bottom: 100,
          right: 0,
          fontSize: "16px",
        }}
        toastOptions={{
          position: "bottom-center",
          style: {
            backgroundColor: "#303030",
            color: "white",
            padding: "12px 14px 12px 24px",
          },
        }}
      />
    </>
  );
}
